import { ReactNode } from 'react';
import Image from 'next/image';
import { cn, getAssetSrc, customImageLoader } from '@restworld/utils-common';
import { Heading, Text } from '@restworld/ui-ds-base';

interface EmployerNoResultsProps {
  title: string;
  content: string;
  buttonEl?: ReactNode;
  contentStyle?: string;
}

function EmployerNoResults({ title, content, buttonEl, contentStyle }: EmployerNoResultsProps) {
  return (
    <Container>
      <Image
        src={getAssetSrc('/utils-assets/not-found.svg')}
        width={160}
        height={150}
        alt="non trovato"
        loader={customImageLoader}
      />
      <Heading weight="medium" className="text-lg text-center">
        {title}
      </Heading>
      <Text weight="medium" className={cn('max-w-sm text-center', contentStyle)}>
        {content}
      </Text>
      {buttonEl}
    </Container>
  );
}
export default EmployerNoResults;

const Container = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('flex flex-col items-center gap-7', className)} {...props} />
);
